<script setup lang="ts">
import { ECharts } from 'echarts'
import stackedImports from '@/charts/home/stacked-imports'

const props = defineProps<{
    values?: Import[]
    country?: string
}>()

const emit = defineEmits<{
    (_e: 'update:country', _country?: string): void
    (_e: 'ready', _instance?: ECharts): void
}>()

/**
 * Chart container.
 */
const container = ref<HTMLElement>()

/**
 * Chart options.
 */
const chartOptions = computed(() => {
    return stackedImports(props.values || [], props.country)
})

/**
 * Register on click event.
 */
function onInstanceCreated(instance?: ECharts) {
    if (instance) {
        emit('ready', instance)
    }

    instance?.on('click', e => {
        if (e.targetType === 'axisLabel' && e.value) {
            emit('update:country', String(e.value))
        } else if (e.name && e.seriesType === 'bar') {
            emit('update:country', e.name)
        }
    })
}

/**
 * ECharts instance.
 */
const { instance } = useChart(container, chartOptions)

watch(instance, onInstanceCreated)
</script>

<template>
    <div ref="container" />
</template>